import type { Data } from "@/types/data";

export interface NavItemConfig {
	label: string;
	href: string;
	enabled?: boolean;
}

export const getNavItems = (data: Data): NavItemConfig[] => [
	{ label: "Início", href: "" },
	{
		label: "Resultados",
		href: "resultados",
		enabled: data["area-resultados"].ativa,
	},
	{
		label: "Exames e dúvidas",
		href: "exames-duvidas",
		enabled: data["area-exames"].ativa,
	},
	{
		label: "Convênios",
		href: "convenios",
		enabled: data["area-convenios"].ativa,
	},
];
